module.exports = seal => seal.substring(seal.length - 1, seal.length)
